import React, { useState } from "react";
import MyOrdersList from "../components/MyOrders/MyOrdersList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import { LiveAuctionCarDetail } from "@common/pages/Dashboard/components/LiveAuction/LiveAuctionCarDetaill";

const MyOrders = () => {

    // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.myOrders}/`)?.[1];

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  // useState variables end...

  if (Vehicle_Id) {
    return <LiveAuctionCarDetail
      selectedCar={selectedCar}
      setSelectedCar={setSelectedCar}
    />;
  }
  
  return <MyOrdersList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      console.log(car, `onCarClick`)
      setSelectedCar(car);
      setDetailView(true);
      navigate(`${routes.dashboardNavigation}${routes.myOrders}/${car?.Vehicle_Id}`);
    }}
  />;
};

export default MyOrders;
